import { V3toVector3, applyTransform, getPivot } from "@project-rouge/rg-three";
import { getCorridorCorners } from "./index153.js";
function getModuleSizeZ(module, apartment) {
  if (apartment.data.closeCorridor && apartment.data.closeDirection) {
    const { start: corridorStart } = getCorridorCorners(module, apartment);
    const facadeStart = V3toVector3(applyTransform(getPivot([0, 0, 0], module), apartment));
    return facadeStart.distanceTo(V3toVector3(corridorStart));
  }
  return module.size[2];
}
export {
  getModuleSizeZ
};
//# sourceMappingURL=index154.js.map
